// extracted by mini-css-extract-plugin
export var createdDate = "_lt-1";
export var divider = "_lt-2";
export var headerDivider = "_lt-3";
export var messagesCard = "_lt-0";
export var messagesContainer = "_lt-7";
export var messagesContainerWrapper = "_lt-4";
export var pointerCapturingButtonBoxes = "_lt-a";
export var showLeftPanelButton = "_lt-9";
export var showMoreButton = "_lt-c";
export var showMoreButtonContainer = "_lt-b";
export var summaryTitle = "_lt-6";
export var systemMessageCardWrapper = "_lt-d";
export var topButtons = "_lt-8";
export var withPadding = "_lt-5";